"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ImageMissing_exports = {};
__export(ImageMissing_exports, {
  default: () => ImageMissing_default
});
module.exports = __toCommonJS(ImageMissing_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M4.03516 3.19922L17.5508 16.7148C17.6419 16.793 17.6875 16.8906 17.6875 17.0078C17.6875 17.125 17.6419 17.2227 17.5508 17.3008C17.4727 17.3919 17.375 17.4375 17.2578 17.4375C17.1406 17.4375 17.043 17.3919 16.9648 17.3008L16.3398 16.6953C16.2227 16.7604 16.0924 16.8125 15.9492 16.8516C15.806 16.8906 15.6562 16.9102 15.5 16.9102H5.5C5.04427 16.9102 4.65365 16.7474 4.32812 16.4219C4.0026 16.0964 3.83984 15.7057 3.83984 15.25V5.25C3.83984 5.09375 3.85938 4.94401 3.89844 4.80078C3.9375 4.65755 3.98958 4.52734 4.05469 4.41016L3.44922 3.78516C3.37109 3.70703 3.33203 3.61589 3.33203 3.51172C3.33203 3.39453 3.37109 3.29036 3.44922 3.19922C3.54036 3.12109 3.63802 3.08203 3.74219 3.08203C3.85938 3.08203 3.95703 3.12109 4.03516 3.19922ZM15.7148 16.0508L13.9375 14.2734H6.61328L8.97656 10.7383L10.4805 13.0039L11.2812 11.6172L8.42969 8.78516C8.36458 8.8112 8.29297 8.83073 8.21484 8.84375C8.14974 8.85677 8.07812 8.86328 8 8.86328C7.67448 8.86328 7.39453 8.7526 7.16016 8.53125C6.9388 8.29688 6.82812 8.01042 6.82812 7.67188C6.82812 7.60677 6.83464 7.53516 6.84766 7.45703C6.86068 7.37891 6.88021 7.30729 6.90625 7.24219L4.69922 5.03516C4.6862 5.07422 4.67318 5.11328 4.66016 5.15234C4.66016 5.17839 4.66016 5.21094 4.66016 5.25V15.25C4.66016 15.4844 4.73828 15.6862 4.89453 15.8555C5.0638 16.0117 5.26562 16.0898 5.5 16.0898H15.5C15.5391 16.0898 15.5716 16.0898 15.5977 16.0898C15.6367 16.0768 15.6758 16.0638 15.7148 16.0508ZM12.1406 10.1328L15.7734 13.7656L12.9023 8.76562L12.1406 10.1328ZM16.3398 5.25V14.332L17.1602 15.1523V5.25C17.1602 4.79427 16.9974 4.40365 16.6719 4.07812C16.3464 3.7526 15.9557 3.58984 15.5 3.58984H5.59766L6.41797 4.41016H15.5C15.7344 4.41016 15.9297 4.49479 16.0859 4.66406C16.2552 4.82031 16.3398 5.01562 16.3398 5.25Z",
      fill: "currentColor"
    }
  )
);
const SvgImageMissing = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var ImageMissing_default = SvgImageMissing;
